export default class ZonasProxi {
  constructor(axios, url) {
    this.axios = axios;
    this.url = url;
  }

  getAll(page, take) {
    return this.axios.get(this.url + `/estudiantes?page=${page}&take=${take}`);
  }

  getListaEstudiante() {
    return this.axios.get(this.url + `/estudiantes/lista`);
  }
  getListEstAulas() {
    return this.axios.get(this.url + `/estudiantes/listaofaulas`);
  }

  create(params) {
    return this.axios.post(this.url + "/estudiantes", params); 
  }

  //================ENVIAR NOTOFICACIONES =================

  createNotificacion(id, params) {
    return this.axios.put(this.url + `/notificacion/${id}`, params);
  }

  createNotificacionEstudiante(id, params) {
    return this.axios.put(this.url + `/notificacion/estudiante/${id}`, params);
  }

  sendNotificacion(params) {
    return this.axios.post(this.url + "/notificacion/mensajes", params);
  }

  sendNotificacionById(params) {
    return this.axios.post(this.url + "/notificacion/mensajesby", params);
  }

   //================FIN NOTOFICACIONES =================

   //================ENVIAR NOTOFICACIONES =================

  sendTelegram(params) {
    return this.axios.post(this.url + "/telegram", params);
  }
  sendTelegramById(params) {
    return this.axios.post(this.url + "/telegram/mensajesby", params);
  }

   //================FIN NOTOFICACIONES =================

  createMany(params) {
    return this.axios.post(this.url + `/estudiantes/alumnosMany`, params); //
  }

  updateMany(params) {
    return this.axios.post(this.url + `/estudiantes/actualizar`, params); //
  }

  get(id) {
    return this.axios.get(this.url + `/estudiantes/${id}`); //representante
  }

  update(id, params) {
    return this.axios.put(this.url + `/estudiantes/${id}`, params);
  }

  updateRepresentante(id, params) {
    return this.axios.put(
      this.url + `/estudiantes/representante/${id}`,
      params
    );
  }

  remove(id) {
    return this.axios.delete(this.url + `/estudiantes/${id}`);
  }

  activateEstudiante(id, state) {
    return this.axios.put(
      this.url + `/estudiantes/activate/${id}?state=${state}`
    );
  }

  async queryEstudiantes(querys) {
    return await this.axios.get(
      this.url + `/estudiantes/query?querys=${querys}`
    );
  }

  //-----------------------------------------PUNTOS DE ATERRISAJE DOCENTES-------------------------

  getAllDocente(page, take) {
    return this.axios.get(this.url + `/docentes?page=${page}&take=${take}`);
  }

  getListaDocente() {
    return this.axios.get(this.url + `/docentes/lista`);
  }

  createDocente(params) {
    return this.axios.post(this.url + "/docentes", params); //alumnosMany
  }

  createManyDocente(params) {
    return this.axios.post(this.url + `/docentes/docentesMany`, params); //
  }

  getDocente(id) {
    return this.axios.get(this.url + `/docentes/${id}`);
  }

  updateDocentePerfil(id, params) {
    return this.axios.put(this.url + `/docentes/perfil/${id}`, params);
  }
  updateDocente(id, params) {
    return this.axios.put(this.url + `/docentes/${id}`, params);
  }

  removeDocente(id) {
    return this.axios.delete(this.url + `/docentes/${id}`);
  }

  activateDocente(id, state) {
    return this.axios.put(this.url + `/docentes/activate/${id}?state=${state}`);
  }

  async queryDocente(querys) {
    return await this.axios.get(this.url + `/docentes/query?querys=${querys}`);
  }

  getRoles() {
    return this.axios.get(this.url + "/users/newrol");
  }

  //-----------------------------------------PUNTOS DE ATERRISAJE CURSOS-------------------------

  getAllCurso(page, take) {
    return this.axios.get(this.url + `/cursos?page=${page}&take=${take}`);
  }

  getListaCurso() {
    return this.axios.get(this.url + `/cursos/lista`);
  }

  createCurso(params) {
    return this.axios.post(this.url + "/cursos", params); //alumnosMany
  }

  updateCurso(id, params) {
    return this.axios.put(this.url + `/cursos/${id}`, params);
  }

  removeCurso(id) {
    return this.axios.delete(this.url + `/cursos/${id}`);
  }

  activateCurso(id, state) {
    return this.axios.put(this.url + `/cursos/activate/${id}?state=${state}`);
  }

  async queryCurso(querys) {
    return await this.axios.get(this.url + `/cursos/query?querys=${querys}`);
  }

  //-----------------------------------------PUNTOS DE ATERRISAJE MATERIAS-------------------------

  getAllMateria(page, take) {
    return this.axios.get(this.url + `/materias?page=${page}&take=${take}`);
  }

  getListaMateria() {
    return this.axios.get(this.url + `/materias/lista`);
  }

  createMateria(params) {
    return this.axios.post(this.url + "/materias", params);
  }

  updateMateria(id, params) {
    return this.axios.put(this.url + `/materias/${id}`, params);
  }

  removeMateria(id) {
    return this.axios.delete(this.url + `/materias/${id}`);
  }

  activateMateria(id, state) {
    return this.axios.put(this.url + `/materias/activate/${id}?state=${state}`);
  }

  async queryMateria(querys) {
    return await this.axios.get(this.url + `/materias/query?querys=${querys}`);
  }

  //-----------------------------------------PUNTOS DE ATERRISAJE PERIODO-------------------------

  getAllPeriodo(page, take) {
    return this.axios.get(this.url + `/periodo?page=${page}&take=${take}`);
  }

  getListaPeriodos() {
    return this.axios.get(this.url + `/periodo/lista`);
  }

  createPeriodo(params) {
    return this.axios.post(this.url + "/periodo", params);
  }

  updatePeriodo(id, params) {
    return this.axios.put(this.url + `/periodo/${id}`, params);
  }

  removePeriodo(id) {
    return this.axios.delete(this.url + `/periodo/${id}`);
  }

  activatePeriodo(id, state) {
    return this.axios.put(this.url + `/periodo/activate/${id}`, state);
  }

  async queryPeriodo(querys) {
    return await this.axios.get(this.url + `/periodo/query?querys=${querys}`);
  }

  //-----------------------------------------PUNTOS DE ATERRISAJE DESYREZAS-------------------------

  getAllDestrezas(page, take) {
    return this.axios.get(this.url + `/destrezas?page=${page}&take=${take}`);
  }

  getListaDestrezas() {
    return this.axios.get(this.url + `/destrezas/lista`);
  }

  getDestrezasById(id) {
    return this.axios.get(this.url + `/destrezas/${id}`);
  }

  createDestrezas(params) {
    return this.axios.post(this.url + "/destrezas", params);
  }

  updateDestrezas(id, params) {
    return this.axios.put(this.url + `/destrezas/${id}`, params);
  }

  removeDestrezas(id) {
    return this.axios.delete(this.url + `/destrezas/${id}`);
  }

  async queryDestrezas(querys) {
    return await this.axios.get(this.url + `/destrezas/query?querys=${querys}`);
  }
  

  /*Rutas para las autoridades de la UE */

  getAutoridades() {
    return this.axios.get(this.url + `/autoridades/lista`);
  }
  editAutoridades(id, params) {
    return this.axios.put(this.url + `/autoridades/${id}`, params);
  }


  /*Rutas de planificacion y de one Drive */

  getDriveById(id) {
    return this.axios.get(this.url + `/drive/${id}`);
  }
  createCarpeta(params) {
    return this.axios.post(this.url + "/drive", params);
  }
  createFile(params) {
    return this.axios.post(this.url + "/drive/file", params);
  }
  updateFolder(id, params) {
    return this.axios.put(this.url + `/drive/${id}`, params);
  }
  removeFolder(id, params) {
    return this.axios.put(this.url + `/drive/removeFolder/${id}`, params);
  }
  removeFile(id, params) {
    return this.axios.put(this.url + `/drive/removeFile/${id}`, params);
  }


 /*Ruta para las fechas de notas */

  getListaFechas() {
    return this.axios.get(this.url + `/fechas/lista`);
  }
  updateFechas(id, params) {
    return this.axios.put(this.url + `/fechas/${id}`, params);
  }
}
